import ReCAPTCHA from "react-google-recaptcha";
import CoreFormHelperText from "../dataDisplay/CoreFormHelperText";
import { useEffect, useState } from "react";
import { backendUrl } from "../../config/api";

export default function CoreCaptcha(props) {
  const { id, formikProps, onChange, captchaRef } = props;
  const [captchaKey, setCaptchaKey] = useState("");

  useEffect(() => {
    getKey();
  }, []);

  const getKey = async () => {
    try {
      let resposne = await fetch(backendUrl + "/captcha/public", {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      if (resposne.status === 200) {
        let data = await resposne.json();
        setCaptchaKey(data.data);
      } else {
        console.error("error in captcha key fetch 500");
      }
    } catch (err) {
      console.error("error in captcha key fetch");
    }
  };

  return captchaKey ? (
    <>
      <ReCAPTCHA ref={captchaRef} id={id} sitekey={captchaKey} onChange={onChange} />
      {formikProps?.errors?.captchaToken && (
        <CoreFormHelperText error>Captcha missing. </CoreFormHelperText>
      )}
    </>
  ) : null;
}
